
import React from "react";
import "./Home.css";

import member1 from "../../assets/LM1.png";
import member2 from "../../assets/LM2.png";
import member3 from "../../assets/LM3.png";
import member4 from "../../assets/LM4.png";
import member5 from "../../assets/LM5.png";
import member6 from "../../assets/LM6.png";
import member7 from "../../assets/LM7.png";

const Home = () => {
  const today = new Date().toLocaleDateString();

  const lifetimeMembers = [
    {
      name: "Faiz Ahmed Faiz",
      designation: "Founder, Ghalib Library",
      image: member1,
    },
    {
      name: "Mirza Zafar-ul-Hasan",
      designation: "Founder Secretary, Ghalib Library",
      image: member2,
    },
    {
      name: "Dr. Sabih-ud-din Rehmani",
      designation: "Lifetime Member",
      image: member3,
    },
    {
      name: "Sarwar Ghazali",
      designation: "Lifetime Member",
      image: member4,
    },
    {
      name: "Abdul Aziz Khan Aziz Ahsan",
      designation: "Lifetime Member",
      image: member5,
    },
    {
      name: "Prof. Dr. Tanzeem-ul-Firdous",
      designation: "Lifetime Member",
      image: member6,
    },
    {
      name: "Dr. Anees Fatima",
      designation: "Lifetime Member",
      image: member7,
    },
  ];

  return (
    <div className="home-container">

      {/* ================= HERO ================= */}

      <section className="home-hero">
        <h1>Welcome to Ghalib Library</h1>

        <p>
          Discover thousands of books, explore different genres,
          stay updated with library events, and enjoy reading.
        </p>

        <div className="home-date">
          📅 {today}
        </div>
      </section>


      {/* ================= SERVICES ================= */}

      <section className="home-section">
        <h2 className="home-section-title">
          Our Services
        </h2>

        <div className="services-grid">

          <div className="service-card">
            <div className="service-icon">📖</div>

            <h3>Browse Books</h3>

            <p>
              Search books by title, author,
              language and genre.
            </p>
          </div>


          <div className="service-card">
            <div className="service-icon">📅</div>

            <h3>Library Events</h3>

            <p>
              View seminars, book fairs,
              workshops and upcoming events.
            </p>
          </div>


          <div className="service-card">
            <div className="service-icon">📚</div>

            <h3>Digital Collection</h3>

            <p>
              Explore a large collection of
              academic and recreational books.
            </p>
          </div>


          <div className="service-card">
            <div className="service-icon">🏛️</div>

            <h3>Peaceful Environment</h3>

            <p>
              A comfortable place for
              learning and research.
            </p>
          </div>

        </div>
      </section>


      {/* ================= LIFETIME MEMBERS ================= */}

      <section className="member-section">

        <h2 className="home-section-title">
          Lifetime Members
        </h2>

        <p className="member-subtitle">
          Honoring the distinguished individuals who have
          contributed to the growth and literary heritage of
          Ghalib Library.
        </p>

        <div className="member-grid">

          {lifetimeMembers.map((member, index) => (
            <div
              key={index}
              className="member-card"
            >
              <img
                src={member.image}
                alt={member.name}
                className="member-image"
              />

              <h3 className="member-name">
                {member.name}
              </h3>

              <p className="member-designation">
                {member.designation}
              </p>
            </div>
          ))}

        </div>
      </section>


      {/* ================= LIBRARY HIGHLIGHTS ================= */}

      <section className="home-section">

        <h2 className="home-section-title">
          Library Highlights
        </h2>

        <div className="stats-grid">

          <div className="stat-card">
            <h2>5000+</h2>
            <p>Books</p>
          </div>

          <div className="stat-card">
            <h2>30+</h2>
            <p>Genres</p>
          </div>

          <div className="stat-card">
            <h2>1000+</h2>
            <p>Members</p>
          </div>

          <div className="stat-card">
            <h2>50+</h2>
            <p>Events</p>
          </div>

        </div>

      </section>


      {/* ================= LIBRARY RULES ================= */}

      <section className="home-section">

        <h2 className="home-section-title">
          Library Rules
        </h2>

        <div className="rules-box">

          <ul>
            <li>
              📚 Maintain silence inside the library.
            </li>

            <li>
              📱 Keep mobile phones on silent mode.
            </li>

            <li>
              📖 Handle books carefully.
            </li>

            <li>
              🪪 Carry your library membership card.
            </li>

            <li>
              ⏰ Return borrowed books on time.
            </li>
          </ul>

        </div>

      </section>


      {/* ================= QUOTE ================= */}

      <section className="quote-box">

        <h2>
          "A reader lives a thousand lives before he dies."
        </h2>

        <p>
          — George R. R. Martin
        </p>

      </section>

    </div>
  );
};

export default Home;
